import { render, staticRenderFns } from "./QuotedQuotation.vue?vue&type=template&id=5d51bc89&"
import script from "./QuotedQuotation.vue?vue&type=script&lang=js&"
export * from "./QuotedQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports